/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    assistiveText: "assistive-text",
    characterLimit: "character-limit",
    content: "content",
    container: "container",
    footer: "footer",
    resizeDisabled: "resize--disabled",
    resizeDisabledX: "resize--disabled-x",
    resizeDisabledY: "resize--disabled-y",
    characterOverLimit: "character--over-limit",
    readOnly: "readonly",
    textAreaInvalid: "text-area--invalid",
    footerSlotted: "footer--slotted",
    hide: "hide",
    footerEndSlotOnly: "footer--end-only",
    textArea: "text-area",
    textAreaOnly: "text-area--only",
};
export const IDS = {
    validationMessage: "textAreaValidationMessage",
};
export const SLOTS = {
    footerStart: "footer-start",
    footerEnd: "footer-end",
};
export const RESIZE_TIMEOUT = 100;
//# sourceMappingURL=resources.js.map
